module.exports = __webpack_public_path__ + "static/media/ae.8f63f623.svg";